import { BlogPost, FetchBlogPostsParams } from '../Types/blog';
import { get, getQSFromObject, post } from './common';
import { isContainerData, LegacyApiContainerInput, normalizeContainer } from '../Types/containerV2';
import { transformDateStringPropsToDate } from '../Utils/dateUtils';

const blogEndpoint = 'api/bloguser';

function mapBlogPost(post: BlogPost | null) {
	if (!post) return;

	return {
		...transformDateStringPropsToDate(post, ['StartTimeUtc']),
		Container: normalizeBlogContainer(post.Container),
	};
}

function normalizeBlogContainer(container: BlogPost['Container'] | LegacyApiContainerInput | null | undefined) {
	if (!container) {
		return null;
	}

	if (isContainerData(container)) {
		return container;
	}

	return normalizeContainer(container);
}

function mapBlogPosts(posts: BlogPost[] | null): BlogPost[] | undefined {
	if (!posts) return;

	return posts.map((post) => mapBlogPost(post)!);
}

export async function getBlogPostByTitle(title: string) {
	const endpoint = `${blogEndpoint}/GetBlogPostByTitle?${getQSFromObject({ title })}`;
	const result = await get<BlogPost>(endpoint);

	return mapBlogPost(result);
}

export async function getBlogPostsInOrder(params: FetchBlogPostsParams) {
	const endpoint = `${blogEndpoint}/GetBlogPostsInOrderForLoggedInUser`;
	const { genericCategoryIds, ...request } = params;
	const result = await post<BlogPost[]>(endpoint, {
		...request,
		categoryIds: genericCategoryIds,
	});
	return mapBlogPosts(result ?? null);
}

export async function getBlogPostsByIds(ids: number[]) {
	if (ids.length === 0) return [];

	const uniqueIds = [...new Set(ids)];
	const result = await post<BlogPost[]>(`${blogEndpoint}/GetBlogPosts`, {
		SpecificIds: uniqueIds,
		PageIndex: 0,
		PageSize: uniqueIds.length,
		UseComments: false,
	});

	return mapBlogPosts(result ?? null) ?? [];
}
